import { FormTemplate } from "components/modal/templates";
import { parseManualValues } from "helpers/form";
import React from "react";
import { alert } from "services/alert";
import { regenerate } from "sources/books/universalTransferDocuments";
import { config, initialState } from "./config";

class RegenerateUniversalTransferDocumentForm extends FormTemplate {
    close = (data = false) => {
        this.setState({ isLoading: false });
        this.props.back?.(data);
    };

    render = () => this.renderBody();

    sendRequest = () => {
        const parsedManualValues = parseManualValues(this.state.manualValues || "");
        if (parsedManualValues === false) {
            alert({ type: "warning", title: "Ошибка", message: "Переопределенные значения должны быть JSON-объектом" });
            this.setState({ isLoading: false });
            return Promise.resolve(false);
        }

        return regenerate({
            id: this.props.id,
            ...(parsedManualValues ? { manualValues: parsedManualValues } : {}),
        });
    };

    renderBodyInner = () => this.renderField(this.props.config.manualValues);

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return <input type="submit" className={cname} value="Перегенерировать" />;
    };
}

export default function ConfiguredRegenerateUniversalTransferDocumentForm(props) {
    return <RegenerateUniversalTransferDocumentForm {...props} config={config} initialState={initialState} />;
}
